import { render, staticRenderFns } from "./Userinfo.vue?vue&type=template&id=8cdb20d0&scoped=true"
import script from "./Userinfo.vue?vue&type=script&lang=js"
export * from "./Userinfo.vue?vue&type=script&lang=js"
import style0 from "./Userinfo.vue?vue&type=style&index=0&id=8cdb20d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cdb20d0",
  null
  
)

export default component.exports